import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'
import CantileverTheme from 'styles/cantileverTheme'

const LATEST_DATA_SCHEMA_VERSION = 3

export const DEFAULT_INSPECTION_TIMELINE_PANEL_DATA: HistogramPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'Inspection Timeline',
  isPinned: true,
  selectedBarIds: [],
  groupingColumn: 'inspection.date',
  aggregationColumn: 'inspection.id',
  aggregationOperation: 'count',
  color: CantileverTheme.colors.blue[400],
  plotType: 'bar',
  orientation: 'v',
  truncateCount: null,
}

export const INSPECTION_TIMELINE_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_INSPECTION_TIMELINE_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
    isDateBucketingConfigurable: true,
    isGroupingColumnConfigurable: false,
    isAggregationColumnConfigurable: false,
    isAggregationOpConfigurable: false,
    isSortDirectionConfigurable: false,
    isPlotTypeConfigurable: false,
    isOrientationConfigurable: false,
  }
